<template>
  <div class="home">
    <h1>Dining App QR Code Readings</h1>
    <p class="subtitle">
      Below are the real-time readings from the App<br />Try to read some QR
      codes from the test app
    </p>
    <CardReading
      v-for="(reading, index) in readings"
      :key="index"
      :qrReading="reading"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardReading from '@/components/CardReading'

export default {
  name: 'Home',
  components: {
    CardReading
  },
  created() {
    this.getReadings()
  },
  computed: {
    ...mapState(['readings'])
  },
  methods: {
    ...mapActions(['getReadings'])
  }
}
</script>

<style>
.home {
  margin: 0 auto;
  max-width: 50%;
  text-align: center;
  align-self: center;
}

.subtitle {
  margin-bottom: 24px;
}
</style>
